"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteRequest = exports.get = exports.put = exports.post = exports.createApiReducer = exports.apiActions = void 0;
var store_1 = require("../store");
var reducers_1 = require("../pages/_shared/reducers");
var TOKEN_HEADER = 'BEARER ';
var ApiInit = {
    isLoading: false,
    errorMessage: null,
    activeCalls: 0,
};
// TODO <T> state:T, ...state
var apiReduceRequest = function (state, action) { return (__assign(__assign({}, state), { isLoading: true, errorMessage: null, activeCalls: state.activeCalls + 1 })); };
var apiReduceSuccess = function (state, action) { return (__assign(__assign({}, state), { isLoading: false, errorMessage: null, activeCalls: Math.max(state.activeCalls - 1, 0) })); };
var apiReduceFailure = function (state, action) { return (__assign(__assign({}, state), { isLoading: false, errorMessage: action.payload.toString(), activeCalls: Math.max(state.activeCalls - 1, 0) })); };
var apiActions = function (api, method) {
    if (method === void 0) { method = ''; }
    return ({
        request: api + method + '_REQUEST',
        fail: api + method + '_FAIL',
        success: api + method + '_SUCCESS',
        message: api + method + '_MESSAGE',
    });
};
exports.apiActions = apiActions;
var createApiReducer = function (api_action) {
    return function (state, action) {
        if (state === void 0) { state = ApiInit; }
        switch (action.type) {
            case (0, exports.apiActions)(api_action).request:
                return __assign({}, apiReduceRequest(state, action));
            case (0, exports.apiActions)(api_action).success:
                return __assign({}, apiReduceSuccess(state, action));
            case (0, exports.apiActions)(api_action).fail:
                return __assign({}, apiReduceFailure(state, action));
            default:
        }
        return state;
    };
};
exports.createApiReducer = createApiReducer;
/**
 *  ----------------------- API CALLS ---------------------
 */
var post = function (url, params, tokenRequired) {
    if (tokenRequired === void 0) { tokenRequired = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.info('POST ', url, JSON.stringify(params));
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: getHeaders(tokenRequired, params instanceof FormData),
                            body: params instanceof FormData ? params : JSON.stringify(params)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, parseResponse(response)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
exports.post = post;
var put = function (url, id, params, tokenRequired) {
    if (tokenRequired === void 0) { tokenRequired = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.info('PUT ', url, params);
                    return [4 /*yield*/, fetch(url + '/' + id, {
                            method: 'PUT',
                            headers: getHeaders(tokenRequired),
                            body: JSON.stringify(params),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, parseResponse(response)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
exports.put = put;
var getHeaders = function (tokenRequired, isFormData) {
    if (tokenRequired === void 0) { tokenRequired = true; }
    if (isFormData === void 0) { isFormData = false; }
    var headers = {
        'authorization': tokenRequired ? TOKEN_HEADER + (0, store_1.getToken)() || '' : '',
        'Accept': 'application/json',
    };
    // Add company filter header for admin/superadmin users
    var selectedCompanyId = (0, store_1.getSelectedCompanyId)();
    if (selectedCompanyId) {
        headers['X-Company-Id'] = selectedCompanyId;
    }
    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }
    return headers;
};
var paramsToUriQuery = function (params) {
    return '?' + Object.keys(params)
        .map(function (key) { return "".concat(key, "=").concat(params[key] instanceof Array ? params[key].join(',') : params[key]); })
        .join('&');
};
var get = function (url, params, tokenRequired) {
    if (tokenRequired === void 0) { tokenRequired = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.info('GET ', url + paramsToUriQuery(params));
                    return [4 /*yield*/, fetch(url + paramsToUriQuery(params), {
                            method: 'GET',
                            headers: getHeaders(tokenRequired),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, parseResponse(response)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
exports.get = get;
var deleteRequest = function (url, params, body, tokenRequired) {
    if (tokenRequired === void 0) { tokenRequired = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.info('DELETE ', url + paramsToUriQuery(params));
                    return [4 /*yield*/, fetch(url + paramsToUriQuery(params), {
                            method: 'DELETE',
                            headers: getHeaders(tokenRequired),
                            body: JSON.stringify(body),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, parseResponse(response)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
exports.deleteRequest = deleteRequest;
var parseResponse = function (response) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Unautorised, log user out. Reject so callers' .fail dispatch fires
                    // and api isLoading state is released (previously the promise hung).
                    if (response.status === 401) {
                        store_1.store.dispatch({ type: reducers_1.LoginActions.LOGOUT });
                        reject('Unauthorized');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    content = _a.sent();
                    if (content.error) {
                        reject(content.error);
                        return [2 /*return*/];
                    }
                    // Response not ok but no server error
                    if (!response.ok) {
                        console.error('Server Error', response);
                        reject('Geen verbinding mogelijk met de server');
                        return [2 /*return*/];
                    }
                    resolve(content);
                    return [2 /*return*/];
            }
        });
    }); });
};
